import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { DirectorySettingsState } from 'src/app/store/dashboard/brick-wall/brick-settings/specific-brick-settings/directory-settings/directory-settings.state';

@Pipe({
   name: 'directoryColumnIsSearchable$',
})
export class DirectoryColumnIsSearchablePipe implements PipeTransform {
   constructor(private store: Store) {}

   transform(directoryColumn: DirectoryColumn, brickInstanceId: string): Observable<boolean> {
      return this.store.select(DirectorySettingsState.getDirectorySearchableColumns).pipe(
         map((fn) => fn(brickInstanceId)),
         map((searchableColumns) => _(searchableColumns).some((x) => x.directoryColumnKey === directoryColumn.directoryColumnKey))
      );
   }
}
